import React from 'react'
import { Link } from 'react-router-dom'

import AddressForm from './AddressForm/AddressForm'

import './Nav.css'
import LogoImage from '../../assets/images/logo.png'

const Nav = ({ slim }) => {
  const logo = <img
    alt={`${process.env.REACT_APP_SITE_TITLE} Logo`}
    className="img-fluid"
    src={LogoImage}
  />

  const returnToUrl = process.env.REACT_APP_RETURN_TO_URL

  return (
    <nav className="navbar navbar-expand-lg navbar-light justify-content-between Nav">
      {returnToUrl.length > 0 ? (
        <a className="navbar-brand Nav__brand" href={returnToUrl}>{logo}</a>
      ) : (
        <Link className="navbar-brand Nav__brand" to="/">{logo}</Link>
      )}
      {!slim && <AddressForm />}
    </nav>
  )
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js